import { render, staticRenderFns } from "./modalGestionarInventario.vue?vue&type=template&id=5f635110"
import script from "./modalGestionarInventario.vue?vue&type=script&lang=js"
export * from "./modalGestionarInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports